module.exports = __webpack_public_path__ + "img/chat_emoticon_tipos_01.png?a371623b84268b436fca7163e795e2ad";